import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "components/common/Box";
import Text from "components/common/Text";
import MenuItem from "components/common/MenuItem";
import Select from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import TextField from "components/common/TextField";
import { Formik } from "formik";
import * as yup from "yup";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import DatePicker from "components/common/DatePicker";
import { Typography } from "@mui/material";
const validateCouponForm = yup.object().shape({
  coupon_code: yup
    .string()
    .required("Coupon code is required")
    .trim("Coupon code cannot contain extra spaces")
    .strict(true)
    .matches(
      /[a-zA-Z0-9]/,
      "Only alphabets and number are allowed for this field "
    ),

  title: yup
    .string()
    .required("Coupon title is required")
    .trim("Coupon code cannot contain extra spaces")
    .strict(true),
  sub_title: yup
    .string()
    .trim("Coupon code cannot contain extra spaces")
    .strict(true)
    .matches(
      /[a-zA-Z0-9]/,
      "Only alphabets and number are allowed for this field "
    ),
  description: yup
    .string()
    .required("Description is required")
    .trim("Description cannot contain extra spaces")
    .strict(true),

  offer: yup
    .string()
    .required("Discount amount is required")
    .trim("Discount amount cannot contain extra spaces")
    .strict(true)
    .matches(/[0-9]/, "Only number are allowed for this field "),

  type: yup.string().required("this field is required"),
});

const AddConnectors = ({ submitCityCoupon, data, Networkdata }) => {
  const [startDate, setStartDate] = React.useState(new Date(""));
  const [endDate, setEndDate] = React.useState(new Date(""));
  const [commondate, setcommondate] = React.useState(new Date(""));
  let history = useHistory();
  const type = ["PERCENTAGE", "AMOUNT"];

  const initialValues = {
    city: "",
    coupon_code: "",
    min_amount: "",
    title: "",
    sub_title: "",
    description: "",
    start_date: "",
    expiry_date: "",
    offer: "",
    type: "",
    network_id: "",
  };

  const onFormSubmit = async (values, reset) => {
    await submitCityCoupon({
      ...values,
      start_date: startDate.date,
      expiry_date: endDate.date,
    });
    reset();
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { resetForm }) => onFormSubmit(values, resetForm)}
        validationSchema={validateCouponForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          values,
          touched,
          errors,
        }) => (
          <>
            <Stack>
              <Text
                variant="h5"
                color="#202020"
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "40px",
                }}
              >
                <ArrowBackIcon
                  sx={{
                    fontSize: "22px",
                    fontWeight: "bold",
                    marginRight: "10px",
                  }}
                  onClick={() => history.goBack()}
                />
                Add coupon
              </Text>

              <Grid
                container
                item
                sx={12}
                direction={{ sm: "column", xs: "column", md: "row" }}
              >
                <Grid item xs={4}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Select city
                  </Text>
                  <Select
                    sx={{ width: "300px", fontSize: "14px" }}
                    size="small"
                    onChange={handleChange("city")}
                    value={values.city}
                    error={!touched.city && Boolean(errors.city)}
                  >
                    {data?.map((e, index) => (
                      <MenuItem sx={{ fontSize: "14px" }} key={index} value={e}>
                        {e}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.city && (
                    <Typography sx={{ color: "red" }}>{errors.city}</Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Select charging network
                  </Text>
                  <Select
                    sx={{ width: "300px", mt: "19", fontSize: "14px" }}
                    size="small"
                    required
                    value={values.network_id}
                    error={!touched.network_id && Boolean(errors.network_id)}
                    onChange={handleChange("network_id")}
                  >
                    {Networkdata?.networks?.map((e, index) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={index}
                        value={e.id}
                      >
                        {e?.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.network_id && (
                    <Typography sx={{ color: "red" }}>
                      {errors.network_id}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Coupon Type
                  </Text>
                  <Select
                    sx={{ width: "300px", mt: "19", fontSize: "14px" }}
                    size="small"
                    value={values.type}
                    error={!touched.type && Boolean(errors.type)}
                    onChange={handleChange("type")}
                  >
                    {type.map((charging, index) => (
                      <MenuItem
                        sx={{ fontSize: "14px" }}
                        key={index}
                        value={charging}
                      >
                        {charging}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.type && (
                    <Typography sx={{ color: "red" }}>{errors.type}</Typography>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                item
                sx={12}
                direction={{ sm: "column", xs: "column", md: "row" }}
              >
                <Grid
                  item
                  xs={4}
                  direction={{ sm: "column", xs: "column", md: "row" }}
                  marginTop="7px"
                >
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Enter coupon code
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      onChange={handleChange("coupon_code")}
                      onBlur={handleBlur("coupon_code")}
                      inputProps={{ style: { fontSize: "14px" } }}
                      error={
                        !touched.coupon_code && Boolean(errors.coupon_code)
                      }
                      value={values.coupon_code}
                    />
                    {errors.coupon_code && (
                      <Typography sx={{ color: "red" }}>
                        {errors.coupon_code}
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={4} marginTop="7px">
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Enter Discount amount (%) or ( &#8377;)
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      inputProps={{ style: { fontSize: "14px" } }}
                      onChange={handleChange("offer")}
                      onBlur={handleBlur("offer")}
                      value={values.offer}
                      error={!touched.offer && Boolean(errors.offer)}
                    />
                    {errors.offer && (
                      <Typography sx={{ color: "red" }}>
                        {errors.offer}
                      </Typography>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={4} marginTop="7px">
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>Title</Text>
                  <Box sx={{ width: "300px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      inputProps={{ style: { fontSize: "14px" } }}
                      onChange={handleChange("title")}
                      onBlur={handleBlur("title")}
                      value={values.title}
                      error={!touched.title && Boolean(errors.title)}
                    />
                    {errors.title && (
                      <Typography sx={{ color: "red" }}>
                        {errors.title}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                item
                sx={12}
                direction={{ sm: "column", xs: "column", md: "row" }}
              >
                <Grid item xs={4} marginTop="7px">
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Sub Title
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      inputProps={{ style: { fontSize: "14px" } }}
                      onChange={handleChange("sub_title")}
                      onBlur={handleBlur("sub_title")}
                      value={values.sub_title}
                    />
                  </Box>
                </Grid>

                <Grid item xs={4} marginTop="7px">
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Description
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <TextField
                      fullWidth
                      size="small"
                      inputProps={{ style: { fontSize: "14px" } }}
                      onChange={handleChange("description")}
                      error={
                        !touched.description && Boolean(errors.description)
                      }
                    />
                    {errors.description && (
                      <Typography sx={{ color: "red" }}>
                        {errors.description}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                item
                sx={12}
                direction={{ sm: "column", xs: "column", md: "row" }}
              >
                <Grid item xs={4} marginTop={1.5}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    Start date
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        minDate={new Date()}
                        selected={startDate}
                        onChange={(newValue) => {
                          setStartDate({ ...startDate, date: newValue });
                          setcommondate(newValue);
                          setEndDate(false);
                         
                        }}
                        value={startDate.date}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        inputProps={{ style: { fontSize: "14px" } }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={4} marginTop={1.5}>
                  <Text sx={{ color: "#666666", fontSize: "14px" }}>
                    End date
                  </Text>
                  <Box sx={{ width: "300px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        selected={endDate}
                        onChange={(newValue) => {
                          setEndDate({ ...endDate, date: newValue });
                        }}
                        value={endDate.date}
                        selectsEnd
                        startDate={commondate}
                        endDate={endDate}
                        minDate={commondate}
                        inputProps={{ style: { fontSize: "14px" } }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
              </Grid>

              <Stack mt={11}>
                <Button
                  variant="contained"
                  sx={{ width: "114.17px", height: "54px", fontSize: "16px" }}
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={!isValid}
                >
                  save
                </Button>
              </Stack>
            </Stack>
          </>
        )}
      </Formik>
    </>
  );
};

export default AddConnectors;
